var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_212_3532)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_212_3532",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 1,
    width: 162,
    height: 148
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 1.5,
    width: 161.7,
    height: 147,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_212_3532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.918 65.3989V62.6762H22.668V61.735L23.4836 61.2356L23.0919 60.596L25.4399 59.1582L25.8315 59.7978L28.1794 58.3601L27.7878 57.7205L30.1357 56.2828L30.5273 56.9224L32.8753 55.4846L32.4836 54.845L34.8315 53.4073L35.2232 54.0469L37.5711 52.6091L37.1794 51.9695L39.5273 50.5318L39.919 51.1714L42.2669 49.7337L41.8753 49.0941L44.2232 47.6563L44.6148 48.2959L46.9628 46.8582L46.5711 46.2186L48.919 44.7808L49.3107 45.4205L51.6586 43.9827L51.2669 43.3431L53.6148 41.9054L54.0065 42.545L56.3544 41.1072L55.9628 40.4676L58.3107 39.0299L58.7023 39.6695L61.0503 38.2318L60.6586 37.5922L63.0065 36.1544L63.3982 36.794L63.4305 36.7742V36.7808H64.1805V39.4714H63.4305V42.1621H64.1805V44.8527H63.4305V47.5433H64.1805V50.234H63.4305V52.9246H64.1805V55.6152H63.4305V58.3058H64.1805V60.9965H63.4305V63.6871H64.1805V66.3777H63.4305V69.0684H64.1805V71.759H63.4305V74.4496H64.1805V77.1402H63.4305V79.8309H64.1805V82.5215H63.4305V85.2121H64.1805V87.9028H63.4305V90.5934H64.1805V93.284H63.4305V95.9746H64.1805V98.6652H63.4305V101.356H64.1805V104.046H63.4305V106.737H64.1805V109.428H63.4305V112.118H64.1805V114.809H63.4305V117.5H64.1805V120.19H63.4305V122.881H64.1805V125.571H63.4305V128.262H64.1805V130.953H63.4305V133.643H64.1805V136.334H63.4305V139.025H64.1805V141.715H63.4305V144.406H64.1805V147.096H63.4305V147.692H62.8598V148.442H60.2184V147.692H57.577V148.442H54.9356V147.692H52.2941V148.442H49.6527V147.692H47.0113V148.442H44.3699V147.692H41.7285V148.442H39.0871V147.692H36.4457V148.442H33.8043V147.692H31.1629V148.442H28.5215V147.692H25.8801V148.442H23.2387V147.692H22.668V147.08H21.918V144.358H22.668V141.635H21.918V138.912H22.668V136.19H21.918V133.467H22.668V130.744H21.918V128.021H22.668V125.299H21.918V122.576H22.668V119.853H21.918V117.131H22.668V114.408H21.918V111.685H22.668V108.962H21.918V106.24H22.668V103.517H21.918V100.794H22.668V98.0715H21.918V95.3488H22.668V92.6261H21.918V89.9034H22.668V87.1807H21.918V84.4579H22.668V81.7352H21.918V79.0125H22.668V76.2898H21.918V73.5671H22.668V70.8444H21.918V68.1216H22.668V65.3989H21.918Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "2.76 2.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.475 26.3761V147.692H58.5V7.96402L119.475 26.3761Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.93 108.996C111.93 104.357 115.691 100.596 120.33 100.596C124.969 100.596 128.73 104.357 128.73 108.996V129.34H111.93V108.996Z",
    fill: "#FAFAFA",
    stroke: "#304FF2",
    strokeWidth: 1.575
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.328,
    cy: 130.127,
    r: 18.375,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.326 124.035L120.326 136.898",
    stroke: "#FAFAFA",
    strokeWidth: 1.575
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.512 84C130.908 71.5065 141.16 61.5 153.75 61.5H167.988C167.592 73.9935 157.34 84 144.75 84H130.512Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.829 59.4918C137.438 51.6285 130.939 45.373 122.979 45.373H114.56C114.951 53.2364 121.45 59.4918 129.41 59.4918H137.829Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5312 73.1045H89.9063",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5312 54.7295H89.9063",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5312 36.3545H89.9063",
    stroke: "black",
    strokeWidth: 1.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_212_3532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliance);
export default __webpack_public_path__ + "static/media/compliance.313a0067db26d9ba905d362621d22a52.svg";
export { ForwardRef as ReactComponent };